// Store de autenticación con Zustand
import { create } from 'zustand'

const useAuthStore = create((set, get) => ({
  // Estado del usuario (con parseo robusto)
  user: (() => {
    try {
      const val = localStorage.getItem('subigol_user')
      return val && val !== 'undefined' ? JSON.parse(val) : null
    } catch (e) {
      return null
    }
  })(),
  token: localStorage.getItem('subigol_token') || null,
  isAuthenticated: !!localStorage.getItem('subigol_token'),
  isLoading: false,

  // Iniciar sesión: guardar usuario y token
  login: (user, token) => {
    localStorage.setItem('subigol_token', token)
    localStorage.setItem('subigol_user', JSON.stringify(user))
    set({ user, token, isAuthenticated: true })
  },

  // Cerrar sesión: limpiar todo
  logout: () => {
    localStorage.removeItem('subigol_token')
    localStorage.removeItem('subigol_user')
    set({ user: null, token: null, isAuthenticated: false })
  },

  // Actualizar datos del usuario
  updateUser: (userData) => {
    const currentUser = get().user
    const updatedUser = { ...currentUser, ...userData }
    localStorage.setItem('subigol_user', JSON.stringify(updatedUser))
    set({ user: updatedUser })
  },

  // Marcar estado de carga
  setLoading: (loading) => set({ isLoading: loading }),
}))

export default useAuthStore
